// import useStyles from './ReportsIndexFilters.styles'
import ReportsFilters from 'modules/reports/components/Filters'
import ReportsFiltersSection from 'modules/reports/components/Filters/Section'
import React from 'react'
import useCore from 'modules/reports/hooks/core'
// import useSearchContext from 'modules/reports/hooks/search'

type Props = {}

function ReportsIndexFilters() {
  // const search = useSearchContext()
  // const classes = useStyles()
  const {t, pt} = useCore('reports', 'components', 'IndexFilters')

  return (
    <ReportsFilters>
      <ReportsFiltersSection title={pt('group-by')}>
        <div>Assets</div>
        <div>Asset categories</div>
        <div>Consumables</div>
        <div>License</div>
        <div>Locations</div>
        <div>Users</div>
      </ReportsFiltersSection>

      <ReportsFiltersSection title={pt('actions')}>
        <div>Assign to Truck</div>
        <div>Assign to User</div>
        <div>Check In</div>
        <div>Check Out</div>
        <div>Condition</div>
        <div>Status</div>
      </ReportsFiltersSection>

      <ReportsFiltersSection title={t('commons.frequency.title')}>
        <div>Daily</div>
        <div>Weekly</div>
        <div>Monthly</div>
        <div>Yearly</div>
        <div>Sunday</div>
        <div>Monday</div>
        <div>Tuesday</div>
        <div>Wednesday</div>
        <div>Thurdsay</div>
        <div>Friday</div>
        <div>Saturday</div>
      </ReportsFiltersSection>

      <ReportsFiltersSection title={pt('last-run-date')}>
        <div>From</div>
        <div>To</div>
      </ReportsFiltersSection>

      <ReportsFiltersSection title={pt('email-users')}>
        <div>user@example.com</div>
        <div>user@example.com</div>
        <div>user@example.com</div>
        <div>user@example.com</div>
        <div>user@example.com</div>
      </ReportsFiltersSection>

      <ReportsFiltersSection title={pt('additional-filters')}>
        <div>Audits</div>
        <div>Changes</div>
      </ReportsFiltersSection>
    </ReportsFilters>
  )
}

export default ReportsIndexFilters
